module.exports = __webpack_public_path__ + "media/images/flags/64/Tajikistan-035d868a7b4d5ef846c99a34ad1f22ce.png";